import { shouldPolyfill } from '@formatjs/intl-listformat/should-polyfill';

export async function loadIntlListFormat(locale) {
  const unsupportedLocale = shouldPolyfill(locale);
  // This locale is supported
  if (!unsupportedLocale) {
    return;
  }
  // Load the polyfill 1st BEFORE loading data
  await import(
    /* webpackChunkName: "polyfill/intl-listformat/polyfill-force" */
    '@formatjs/intl-listformat/polyfill-force'
  );
  await import(
    /* webpackChunkName: "polyfill/intl-listformat/locale-data" */
    `@formatjs/intl-listformat/locale-data/${unsupportedLocale}.js`
  );
}
